import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ChatBubble = ({
  size,
  type,
  theme,
  className,
  dataTestId = "chat-bubble-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g clipPath="url(#a)">
      <path d="M4.667 6c0-.368.298-.667.666-.667h5.334a.667.667 0 1 1 0 1.334H5.333A.667.667 0 0 1 4.667 6ZM5.333 8a.667.667 0 0 0 0 1.333H8A.667.667 0 1 0 8 8H5.333Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.916 2.601C3.021 1.346 4.926.667 8 .667s4.98.68 6.084 1.934c1.092 1.241 1.25 2.884 1.25 4.4 0 1.517-.162 3.103-.94 4.317-.775 1.211-2.08 1.936-4.056 2.01l-1.271 1.694c-.534.711-1.6.711-2.134 0l-1.271-1.695c-1.976-.073-3.281-.798-4.057-2.01C.828 10.105.667 8.519.667 7c0-1.515.157-3.158 1.25-4.399Zm1.001.881C2.176 4.325 2 5.515 2 7c0 1.482.172 2.73.728 3.599C3.243 11.403 4.166 12 6 12c.21 0 .407.099.533.267L8 14.222l1.467-1.955A.667.667 0 0 1 10 12c1.834 0 2.757-.597 3.272-1.401C13.828 9.729 14 8.482 14 7c0-1.485-.176-2.675-.917-3.518C12.353 2.654 10.926 2 8 2s-4.354.654-5.083 1.482Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </SVGIcon>
);
